import React, { Component } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-solid-svg-icons'

import './playlist.css';

class Playlist extends Component {

    copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(function () {
            console.log('Async: Copying to clipboard was successful!');
        }, function (err) {
            console.error('Async: Could not copy text: ', err);
        });
    }


    render() {
        const embedURL = `https://open.spotify.com/embed/playlist/${this.props.playlistLink}`
        const element = <FontAwesomeIcon icon={faCopy} onClick={() => { this.copyToClipboard(this.props.playlistTitle) }} />

        return (
            <div className="playlist">
                <div className="title"><b>{this.props.playlistTitle}</b> {element}</div>
                <iframe src={embedURL} title="sdf"
                    width="500" height="300" frameBorder="0" allowtransparency="true" allow="encrypted-media">
                </iframe>
            </div>
        );
    }
}

export default Playlist;